import type { RowData } from "@tanstack/react-table";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { TableDragHandleCell } from "./TableDragHandleCell";
import { TableRow, type TableRowProps } from "./TableRow";

export type TableSortableRowProps<TRow extends RowData> = Omit<TableRowProps<TRow>, "dragHandle" | "ref" | "style">;

export const TableSortableRow = <TRow extends RowData>(props: TableSortableRowProps<TRow>) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: props.row.id,
  });

  return (
    <TableRow
      {...props}
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : undefined,
        position: "relative",
        zIndex: isDragging ? 1 : undefined,
      }}
      dragHandle={<TableDragHandleCell ref={setActivatorNodeRef} attributes={attributes} listeners={listeners} />}
    />
  );
};
